import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Header from "../../components/Header";
import { Col, Row, Container, Nav } from "reactstrap";
import EtimWizard from "../../components/ETIM/EtimWizard";
import EtimProgress from "../../components/ETIM/EtimProgress";
import { EtimProvider, useEtim } from "../../context/ETIMContext";
import EtimHeader from "../../components/ETIM/EtimHeader";
import EtimModalWizard from "../../components/ETIM/EtimModalWizard";
import { fireAlert } from "../../utils/alerts";
import ErrorSummary from "../../components/ProductCreation/ErrorSummary";

const EditContent = (props) => {
  const { id, classEtim, isModal } = props;
  const { setEtim, etim, validate } = useEtim();
  const [modalProgress, setModalProgress] = useState("select");
  const location = useLocation();

  useEffect(() => {
    if (id) {
      setEtim({
        type: "SET_SERIES_ID",
        payload: id,
      });
    }
    if (classEtim) {
      setEtim({
        type: "SET_CLASS_ETIM",
        payload: classEtim,
      });
    }
  }, []);

  const intl = useIntl();
  const history = useHistory();
  const basePath = `/series/etim/edit/${etim.seriesId}`;

  const onNext = async () => {
    if ((await validate()) == false) return;
    const currentPath = history.location.pathname;
    if (currentPath == basePath) history.push(`${basePath}/${etim.classEtim}/characteristics`);
    else if (currentPath.includes("characteristics")) history.push(`${basePath}/${etim.classEtim}/summary`);
  };

  const onPrevious = async () => {
    if ((await validate()) == false) return;
    const currentPath = history.location.pathname;
    if (currentPath.includes("characteristics")) history.push(`${basePath}`);
    else if (currentPath.includes("summary")) history.push(`${basePath}/${etim.classEtim}/characteristics`);
  };

  const progressItems = {};

  if (isModal) {
    progressItems.select = {
      name: "select",
      to: "",
      disabled: false,
      description: intl.formatMessage({
        id: "etim.define_class",
        defaultMessage: "Select ETIM Class *",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        setModalProgress("select");
      },
    };
    progressItems.characteristics = {
      name: "characteristics",
      to: "",
      disabled: etim.classEtim == null || etim.classEtim == "",
      description: intl.formatMessage({
        id: "etim.define_characteristics",
        defaultMessage: "Define characteristics",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        setModalProgress("characteristics");
      },
    };
    progressItems.finish = {
      name: "finish",
      to: "",
      disabled: etim.classEtim == null || etim.classEtim == "" || etim.groupedProducts.length === 0,
      description: intl.formatMessage({
        id: "etim.finish",
        defaultMessage: "Finish ETIM product creation",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        setModalProgress("finish");
      },
    };
  } else {
    progressItems.select = {
      name: "select",
      to: `/series/etim/edit/${etim.seriesId}`,
      disabled: false,
      description: intl.formatMessage({
        id: "etim.define_class",
        defaultMessage: "Select ETIM Class *",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        return history.push(`/series/etim/edit/${etim.seriesId}`);
      },
    };

    progressItems.characteristics = {
      name: "characteristics",
      to: `/series/etim/edit/${etim.seriesId}/${etim.classEtim}/characteristics`,
      disabled: etim.classEtim == null || etim.classEtim == "",
      description: intl.formatMessage({
        id: "etim.define_characteristics",
        defaultMessage: "Definecharacteristics",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        return history.push(`/series/etim/edit/${etim.seriesId}/${etim.classEtim}/characteristics`);
      },
    };

    progressItems.finish = {
      name: "finish",
      to: `/series/etim/edit/${etim.seriesId}/${etim.classEtim}/summary`,
      disabled: etim.classEtim == null || etim.classEtim == "" || etim.groupedProducts.length === 0,
      description: intl.formatMessage({
        id: "etim.finish",
        defaultMessage: "Define characteristics",
      }),
      onclick: async (e) => {
        e.preventDefault();
        if ((await validate()) == false) return;
        return history.push(`/series/etim/edit/${etim.seriesId}/${etim.classEtim}/summary`);
      },
    };
  }

  const onModalNext = async () => {
    if ((await validate()) == false) return;

    if (modalProgress === "select") setModalProgress("characteristics");
    else if (modalProgress === "characteristics") setModalProgress("finish");
  };

  const onModalPrevious = async () => {
    if ((await validate()) == false) return;
    if (modalProgress === "characteristics") setModalProgress("select");
    else if (modalProgress === "finish") setModalProgress("characteristics");
  };

  const getActiveItem = () => {
    if (isModal) {
      return progressItems[modalProgress]?.name || "select";
    } else {
      const currentPath = location.pathname;
      return Object.values(progressItems).find((x) => x.to == currentPath)?.name || "select";
    }
  };

  const handleSelectionNext = async () => {
    if ((await validate()) == false) return;
    if (etim.classEtim) {
      isModal ? setModalProgress("characteristics") : history.push(`/series/etim/edit/${etim.seriesId}/${etim.classEtim}/characteristics`);
    } else {
      alert("Please select a final ClaseETIM.");
    }
  };

  const handleCharacteristicsNext = async () => {
    if ((await validate()) == false) return;
    if (etim.classEtim && etim.groupedProducts.length > 0) {
      isModal ? setModalProgress("finish") : history.push(`/series/etim/edit/${etim.seriesId}/${etim.classEtim}/summary`);
    } else {
      alert("Please select a final ClaseETIM.");
    }
  };

  return (
    <>
      <EtimHeader />
      <Row>
        <Col md="3">
          <EtimProgress
            items={progressItems}
            onNext={isModal ? onModalNext : onNext}
            onPrevious={isModal ? onModalPrevious : onPrevious}
            isModal={isModal}
            activeItem={getActiveItem()}
          />
        </Col>
        <Col md="9">
          <div className="product-creation-wizard">
            <div className="product-creation-wizard">
              {isModal ? (
                <EtimModalWizard
                  {...props}
                  progress={modalProgress}
                  handleSelectionNext={handleSelectionNext}
                  handleCharacteristicsNext={handleCharacteristicsNext}
                  classEtim={etim.classEtim}
                />
              ) : (
                <EtimWizard handleSelectionNext={handleSelectionNext} handleCharacteristicsNext={handleCharacteristicsNext} />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default function Edit(props) {
  const { isModal } = props;
  const { id, classEtim } = isModal ? { id: props.id, classEtim: props.classEtim } : props.match.params;

  return (
    <EtimProvider>
      <Header classes={isModal ? "header pb-3 pt-3 pt-md-0" : null}>
        <h1>
          <FormattedMessage id="etim.select_title" defaultMessage="Select ETIM Class *" />
        </h1>
      </Header>
      <Container fluid>
        <EditContent id={id} classEtim={classEtim} isModal={isModal} />
      </Container>
    </EtimProvider>
  );
}
